<template>
  <StoreLocatorConfigSection
    :title="$t('message.storeLocator.floatingButton.title')"
  >
    <div class="sl-floating-button-section">
      <p class="sl-floating-button-section__subtitle">
        {{ $t("message.storeLocator.floatingButton.subtitle") }}
      </p>
      <div class="sl-floating-button-section__form">
        <v-text-field
          :label="$t('message.storeLocator.floatingButton.text')"
          v-model="form.text"
        ></v-text-field>
        <v-text-field
          :label="$t('message.storeLocator.basic.url')"
          v-model="form.url"
        ></v-text-field>
      </div>
    </div>
  </StoreLocatorConfigSection>
</template>

<script>
const defaultForm = {
  text: "",
  url: ""
};

import StoreLocatorConfigSection from "@/components/StoreLocator/StoreLocatorConfigSection";

export default {
  name: "StoreLocatorConfigFloatingButton",
  components: {
    StoreLocatorConfigSection
  },
  props: {
    config: {
      type: Object
    }
  },
  data: () => ({
    form: null
  }),
  watch: {
    config: {
      handler() {
        this.setForm();
      },
      deep: true
    },
    form: {
      handler(data) {
        this.$emit("form-change", data);
      },
      deep: true
    }
  },
  created() {
    this.setForm();
  },
  methods: {
    setForm() {
      if (this.config) {
        const { external_button_link_name, external_button_link } = this.config;
        this.form = {
          text: external_button_link_name,
          url: external_button_link
        };
      } else {
        this.form = { ...defaultForm };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sl-floating-button-section {
  display: flex;
  flex-direction: column;

  &__subtitle {
    @include font-size(13px);
  }

  &__form {
    flex: 1 1 auto;
  }
}
</style>
